export enum VehicleType {
  Bicycle = "Bicycle",
  Motorcycle = "Motorcycle",
  PrivateCar = "PrivateCar",
  Van = "Van",
  Truck = "Truck",
  Forklift = "Forklift",
  Trailer = "Trailer",
  Tractor = "Tractor",
  ElectricCar = "ElectricCar",
  ElectricTruck = "ElectricTruck",
  ElectricVan = "ElectricVan"
}
